export default "__VITE_ASSET__DlYhANJt__"